import LayoutPage from "../../Components/LayoutPage"
import KYCList from "./Components/KYCList"


export default function KYC() {
  return (
    <LayoutPage activeIndex={6} navItems={["احراز هویت مشتریان"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <KYCList/>
    </LayoutPage>
  )
}